import {createProjectModel} from 'company-management/utils/project-model'
import {getTokenForStorage, setTokenForStorage, removeTokenForStorage} from '../utils'

const model = createProjectModel({
    projectNamespace: 'base',
    state: {
        accessToken: getTokenForStorage(),
    },

    effects: {},

    reducers: {
        immerSetAccessToken(state, action) {
            const {accessToken = ''} = action.payload
            setTokenForStorage(accessToken)

            state.accessToken = accessToken
        },
        immerRemoveAccessToken(state) {
            removeTokenForStorage()
            delete state.accessToken
        },
    },
})

export default model
